import * as _ from "lodash";
import * as log from "loglevel";
import { action, autorun, computed, observable, reaction, runInAction } from "mobx";
import { Agent } from "../../services/agent";
import { App } from "./app";
import { BaseModel } from "./base-model";

export class AppAction extends BaseModel{
	@observable selected: boolean = false;
	@observable name : string;
	@observable description : string;
	@observable externalId: string;
	@observable appId: string;
	@observable projectId: string;
	@observable app: App;

	constructor(data : any = {}) {
		super(data);
	}

	@action select(){
		this.selected = true;
	}

	@action deselect(){
		this.selected = false;
	}

	@action toggleSelection(){
		this.selected = !this.selected;
	}

	@action async save(){
		let result = await Agent.Actions.save(this.id, this);

		runInAction(() => this.fromJSON(result));
	}
}



// WEBPACK FOOTER //
// ./src/stores/models/app-action.ts